<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-6 text-left">
          <h4>Email template</h4>
        </div>
        <div class="col-6 text-right">
          <appModalEmailTemplateNew></appModalEmailTemplateNew>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <b-form-select
              plain
              :options="getEmailTemplateDropdownList"
              value-field="id"
              text-field="title"
              placeholder=" "
              autocomplete="off_post_address_state"
              v-model="templateId"
              @change="fnChangeTemplate(templateId)"
            ></b-form-select>
            <label class="floatingLabel" for="state">Select template</label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder=""
              v-model="subject"
            />
            <label class="floatingLabel" for="subject">Subject</label>
            <div class="invalid-feedback" v-if="errors.title">
              {{ errors.subject[0] }}
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="" for="note"
          >Content
          <span class="fs-700 text-danger"
            >(Only require body. No need title or signature or footer)</span
          ></label
        >
        <vue-editor v-model="content" :editor-toolbar="customToolbar" />
        <div class="invalid-feedback" v-if="errors.content">
          {{ errors.content[0] }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import appModalEmailTemplateNew from '../emailTemplate/ModalEmailTemplateNew.vue'

export default {
  name: 'employerList',
  components: {
    appModalEmailTemplateNew
  },
  data() {
    return {
      errors: {},
      subject: '',
      templateId: '',
      content: '',
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }]
      ]
    }
  },
  computed: {
    ...mapGetters(['getEmailTemplateDropdownList', 'getEMWizardData'])
  },
  methods: {
    ...mapActions(['fetchEmailTemplateDropdownList', 'fetchEMWizardData']),
    fnChangeTemplate(id) {
      let list = this.getEmailTemplateDropdownList
      let selectContent = list.find((item) => item.id == id)
      this.content = selectContent?.content
    }
  },
  mounted() {
    this.fetchEmailTemplateDropdownList({ categoryId: 3 })
  },
  watch: {
    subject(newValue) {
      let obj = { subject: newValue }
      this.fetchEMWizardData({ ...this.getEMWizardData, ...obj })
    },
    content(newValue) {
      let obj = { content: newValue }
      this.fetchEMWizardData({ ...this.getEMWizardData, ...obj })
    }
  }
}
</script>
